/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const MicrosoftTeams = defineMessages({
  titleOne: {
    id: 'MicrosoftTeams.MicrosoftTeams.titleOne',
    defaultMessage: 'Your customers are on Microsoft Teams'
  },
  titleTwo: {
    id: 'MicrosoftTeams.MicrosoftTeams.titleTwo',
    defaultMessage: 'Your assistant can be too'
  },
  subtitle: {
    id: 'MicrosoftTeams.MicrosoftTeams.subtitle',
    defaultMessage:
      'With Teams, your assistant can collaborate with the people, content, and tools you need. <link>Learn more</link>'
  },
  instructions: {
    id: 'MicrosoftTeams.MicrosoftTeams.instructions',
    defaultMessage: 'Steps to setting up Microsoft Teams:'
  },
  instructionsDescription: {
    id: 'MicrosoftTeams.MicrosoftTeams.instructionsDescription',
    defaultMessage:
      "Select Create to get all the details, but here's what to expect:"
  },
  instructionsItemOne: {
    id: 'MicrosoftTeams.MicrosoftTeams.instructionsItemOne',
    defaultMessage: 'Create a new app registration within Microsoft Azure.'
  },
  instructionsItemTwo: {
    id: 'MicrosoftTeams.MicrosoftTeams.instructionsItemTwo',
    defaultMessage: 'Create your bot.'
  },
  instructionsItemThree: {
    id: 'MicrosoftTeams.MicrosoftTeams.instructionsItemThree',
    defaultMessage: 'Create a Teams app.'
  },
  instructionsItemFour: {
    id: 'MicrosoftTeams.MicrosoftTeams.instructionsItemFour',
    defaultMessage: 'Publish your bot.'
  }
});
